import { queryOptions } from '@tanstack/react-query';
import { apiClient } from 'lib/api';
import type { Network } from 'types/shared';
import type { References } from '../types';
import type { QueryFunctionContext } from '@tanstack/react-query';

export const getReferences = async ({ queryKey, signal }: QueryFunctionContext<[string]>): Promise<References> => {
  const res = await apiClient.get<References>(queryKey[0].toString(), {
    signal,
  });
  return res.data;
};

export const REFERENCES_KEY = (network: Network) => (network === 'facebook' ? '/references' : 'ga/references');

export const getReferencesOptions = (network: Network) => {
  return queryOptions({
    queryFn: getReferences,
    queryKey: [REFERENCES_KEY(network)],
    staleTime: 60 * 30 * 1000,
  });
};
